import React, { useContext, useRef, useState, useEffect } from "react";

// import Breadcrumps from "../../components/Breadcrumps";
import Toptab from "../Toptab/Toptab";
import Breadcrumps from "../Toptab/Breadcrumps";
import { AppContext } from "../../../context/AppContext";
import { multipartPostCallWithErrorResponse, simpleGetCall, simplePostCallIVT, PutCallWithAuthToken } from "../../../api/ApiServices";
// import ApiConfig from "../../../api/ApiConfig";
import { toast } from "react-toastify";
import { ToastMsg } from "../../TostMsg";
import { Spinner } from "react-bootstrap";
import { notifyError } from "../../../toaster/notify";
import StoreSelector from "../../StoreSelector";

const BaseMenu = () => {

  const { sidebar, activeTab, setActiveTab, selectedStoreID, ApiConfig, storesList,
    setSelectedStoreID,
    permissions } = useContext(AppContext);

  let ref = useRef(null)
  let ref2 = useRef(null)
  const menuDropdownRef = useRef(null);
  const contextMenuRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [syncloading, setSyncLoading] = useState(false);

  // Menu list state
  const [menuList, setMenuList] = useState([]);
  const [selectedMenu, setSelectedMenu] = useState({
    name:'Base menu'
  });
  console.log('taleeb_selectedMenu--',selectedMenu)
  const [menuLoading, setMenuLoading] = useState(false);
  const [showMenuDropdown, setShowMenuDropdown] = useState(false);
  const [showContextMenu, setShowContextMenu] = useState(false);

  // Create menu modal state
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [newMenuName, setNewMenuName] = useState("");
  const [cloneFromId, setCloneFromId] = useState("");
  const [createLoading, setCreateLoading] = useState(false);
  const [cloneMenuItems, setCloneMenuItems] = useState([]);
  const [cloneItemsLoading, setCloneItemsLoading] = useState(false);
  const [editingMenu, setEditingMenu] = useState(null);

  const fetchCloneMenuItems = (menuId) => {
    if (!selectedStoreID) return;
    setCloneItemsLoading(true);
    setCloneMenuItems([]);
    const url = ApiConfig.BASE_URL_IN +
      `products/menu/items-lookup?shop_id=${selectedStoreID}${menuId ? `&menu_id=${menuId}` : ""}`;
    simpleGetCall(url)
      .then((res) => {
        if (res?.success && Array.isArray(res?.data)) {
          setCloneMenuItems(res.data);
        }
      })
      .catch((err) => console.error("Clone items fetch error:", err))
      .finally(() => setCloneItemsLoading(false));
  };

  useEffect(() => {
    fetchCloneMenuItems(cloneFromId);
  }, [cloneFromId]);

  const DAYS = [
    { value: "mon", label: "Monday" },
    { value: "tue", label: "Tuesday" },
    { value: "wed", label: "Wednesday" },
    { value: "thu", label: "Thursday" },
    { value: "fri", label: "Friday" },
    { value: "sat", label: "Saturday" },
    { value: "sun", label: "Sunday" },
  ];

  const emptyScheduleRow = () => ({ day_of_week: "", start_time: "", end_time: "", start_date: "", end_date: "" });
  const [schedule, setSchedule] = useState([emptyScheduleRow()]);

  const updateScheduleRow = (index, field, value) => {
    setSchedule((prev) => prev.map((row, i) => i === index ? { ...row, [field]: value } : row));
  };

  const addScheduleRow = () => setSchedule((prev) => [...prev, emptyScheduleRow()]);

  const removeScheduleRow = (index) => setSchedule((prev) => prev.filter((_, i) => i !== index));

  // ── existing functions ──────────────────────────────────────────────────────

  const handleEcxportProducs = (e, type) => {

    let formData = new FormData()

    formData.append('shop_id', selectedStoreID)
    formData.append('file', e.target.files[0])

    const url = type === "pooja" ? ApiConfig.POST_SYNC_PET_POOJA : ApiConfig.IMPORT_PRODUCTS;
    if (type === 'pooja') {
      setSyncLoading(true)
    }
    multipartPostCallWithErrorResponse(url, formData).then((res) => {

      if (res.json.success) {
        ToastMsg('success', res?.json.message)
      } else {
        ToastMsg('error', res?.json.message || "Something went wrong")
      }

    }).catch((error) => {

    }).finally(() => {
      setSyncLoading(false)
    })

  }

  function downloadExcelFromResponse(response, fileName = 'report.xlsx') {
    setLoading(true);
    response.blob().then(blob => {
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);
    });

    setLoading(false);
  }

  const getExportProduct = async () => {
    setLoading(true);
    if (!selectedStoreID) {
      notifyError("Please select a restaurant");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(
        ApiConfig.EXPORT_PRODUCTS(selectedStoreID),
        {
          method: 'GET',
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("Token"),
          },
        }
      );

      if (!response.ok) {
        throw new Error('Download failed');
      }

      downloadExcelFromResponse(response, 'products.xlsx');
    } catch (err) {
      notifyError("Something went wrong")
      console.error('Status API Error:', err);
    } finally {
      setLoading(false);
    }
  };

  // ── menu list API ───────────────────────────────────────────────────────────

  const fetchMenuList = () => {
    console.log('my nane is taleeb--', selectedStoreID,ApiConfig.GET_MENU(selectedStoreID))
    if (!selectedStoreID ) return;
    setMenuLoading(true);
    simpleGetCall(ApiConfig.GET_MENU(selectedStoreID))
      .then((res) => {
        if (res?.success && Array.isArray(res?.data)) {
          setMenuList(res.data);
          if (res.data.length > 0) {
            const defaultMenu = res.data.find((m) => m.is_default) || res.data[0];
            setSelectedMenu((prev) => prev ?? defaultMenu);
          }
        }
      })
      .catch((err) => console.error("Menu fetch error:", err))
      .finally(() => setMenuLoading(false));
  };

  useEffect(() => {
     if (!selectedStoreID ) return;
    fetchMenuList();
  }, [selectedStoreID]);

  // Close dropdowns on outside click
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (menuDropdownRef.current && !menuDropdownRef.current.contains(e.target)) {
        setShowMenuDropdown(false);
      }
      if (contextMenuRef.current && !contextMenuRef.current.contains(e.target)) {
        setShowContextMenu(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  // Create / Update menu
  const handleCreateMenu = () => {
    if (!newMenuName.trim()) {
      ToastMsg("error", "Version Name is required");
      return;
    }
    if (!selectedStoreID) {
      notifyError("Please select a restaurant");
      return;
    }
    setCreateLoading(true);

    const cleanSchedule = schedule
      .filter((s) => s.day_of_week && s.start_time && s.end_time)
      .map((s) => ({
        day_of_week: s.day_of_week,
        start_time: s.start_time,
        end_time: s.end_time,
        ...(s.start_date ? { start_date: s.start_date } : {}),
        ...(s.end_date ? { end_date: s.end_date } : {}),
      }));
    const mappedItems = cloneMenuItems
      .filter((item) => item.id != null)
      .map((item) => ({
        menu_item_id: item.id,
        price_override: parseFloat(item.item_price) || 0,
        is_available: item.is_available,
        ...(item.variations ? { variations: item.variations } : {}),
        ...(item.item_description ? { description_override: item.item_description } : {}),
      }));

    if (editingMenu) {
      // ── UPDATE mode ──────────────────────────────────────────────────────────
      const body = JSON.stringify({
        name: newMenuName.trim(),
        restaurant_id: Number(selectedStoreID),
        ...(editingMenu.order_type != null ? { order_type: editingMenu.order_type } : {}),
        is_active: editingMenu.is_active ?? true,
        is_default: editingMenu.is_default ?? false,
        priority: editingMenu.priority ?? 0,
        ...(cleanSchedule.length > 0 ? { schedule: cleanSchedule } : {}),
        ...(mappedItems.length > 0 ? { items: mappedItems } : {}),
      });
      PutCallWithAuthToken(ApiConfig.PUT_UPDATE_MENU(editingMenu.id), body)
        .then(({ json: res }) => {
          if (res?.success) {
            ToastMsg("success", res?.message || "Menu updated successfully");
            setShowCreateModal(false);
            setNewMenuName("");
            setCloneFromId("");
            setEditingMenu(null);
            fetchMenuList();
          } else {
            ToastMsg("error", res?.message || "Something went wrong");
          }
        })
        .catch((err) => console.error("Update menu error:", err))
        .finally(() => setCreateLoading(false));
    } else {
      // ── CREATE mode (unchanged) ───────────────────────────────────────────────
      const body = JSON.stringify({
        name: newMenuName.trim(),
        restaurant_id: Number(selectedStoreID),
        ...(cloneFromId ? { clone_from: Number(cloneFromId) } : {}),
        ...(cleanSchedule.length > 0 ? { schedule: cleanSchedule } : {}),
        ...(mappedItems.length > 0 ? { items: mappedItems } : {}),
      });
      simplePostCallIVT(ApiConfig.POST_CREATE_MENU, body)
        .then((res) => {
          if (res?.success) {
            ToastMsg("success", res?.message || "Menu created successfully");
            setShowCreateModal(false);
            setNewMenuName("");
            setCloneFromId("");
            fetchMenuList();
          } else {
            ToastMsg("error", res?.message || "Something went wrong");
          }
        })
        .catch((err) => console.error("Create menu error:", err))
        .finally(() => setCreateLoading(false));
    }
  };

  const handleEditMenu = (menu) => {
    setEditingMenu(menu);
    setNewMenuName(menu.name);
    setSchedule(
      menu.schedule && menu.schedule.length > 0
        ? menu.schedule.map((s) => ({
            day_of_week: s.day_of_week || "",
            start_time: s.start_time || "",
            end_time: s.end_time || "",
            start_date: s.start_date || "",
            end_date: s.end_date || "",
          }))
        : [emptyScheduleRow()]
    );
    setCloneFromId("");
    fetchCloneMenuItems(menu.id);
    setShowMenuDropdown(false);
    setShowCreateModal(true);
  };

  const handleCloseCreateModal = () => {
    setShowCreateModal(false);
    setNewMenuName("");
    setCloneFromId("");
    setCloneMenuItems([]);
    setSchedule([emptyScheduleRow()]);
    setEditingMenu(null);
  };

  // ── render ──────────────────────────────────────────────────────────────────

  return (
    <div
      className={sidebar ? "taskMain " : "cx-active taskMain"}
      id="cx-main"
    >
      {/* Hidden file inputs – unchanged */}
      <input type="file" style={{ display: 'none' }}
        ref={ref}
        onChange={(e) => handleEcxportProducs(e, 'normal')}
        accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      />
      <input type="file" style={{ display: 'none' }}
        ref={ref2}
        onChange={(e) => handleEcxportProducs(e, 'pooja')}
        accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      />

      <div className="role-content">
        <div className="sub-header-role" style={{ alignItems: "center", flexWrap: "nowrap", gap: "12px" }}>

          {/* ── Left group: label + menu selector ── */}
          <div style={{ display: "flex", alignItems: "center", gap: "2rem", flexShrink: 0 }}>
            <h6 style={{ margin: 0, fontWeight: 700, whiteSpace: "nowrap", fontSize: "15px" }}>Menu List</h6>

            {/* Menu dropdown + add button */}
            <div ref={menuDropdownRef} style={{ position: "relative", display: "flex", alignItems: "center", gap: "6px" }}>

              {/* Dropdown trigger */}
               {permissions &&
                                  permissions["Manage Menu List"] && (
                                    <>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid #dee2e6",
                  borderRadius: "6px",
                  padding: "0 12px",
                  cursor: "pointer",
                  minWidth: "170px",
                  height: "36px",
                  background: "#fff",
                  userSelect: "none",
                }}
                onClick={() => setShowMenuDropdown((v) => !v)}
              >
                <span style={{ flex: 1, fontSize: "13px", color: "#333", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {menuLoading ? <Spinner size="sm" /> : (selectedMenu ? selectedMenu.name : "Base Menu")}
                </span>
                <svg width="11" height="11" viewBox="0 0 12 12" fill="none" style={{ marginLeft: "8px", flexShrink: 0 }}>
                  <path d="M2 4L6 8L10 4" stroke="#888" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>

              {/* Add button  */}
              <button
                title="Create new menu"
                style={{
                  background: "#53B7E8",
                  border: "none",
                  borderRadius: "6px",
                  width: "36px",
                  height: "36px",
                  cursor: "pointer",
                  color: "#fff",
                  fontSize: "22px",
                  fontWeight: 300,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  lineHeight: 1,
                }}
                onClick={() => { setShowCreateModal(true); setShowMenuDropdown(false); fetchCloneMenuItems(""); }}
              >
                +
              </button>
              </>
            )}
              {/* Dropdown list */}
              {showMenuDropdown && (
                <div style={{
                  position: "absolute",
                  top: "calc(100% + 6px)",
                  left: 0,
                  background: "#fff",
                  border: "1px solid #dee2e6",
                  borderRadius: "6px",
                  zIndex: 1000,
                  minWidth: "200px",
                  boxShadow: "0 6px 20px rgba(0,0,0,0.10)",
                  overflow: "hidden",
                }}>
                  {menuLoading ? (
                    <div style={{ padding: "12px", textAlign: "center" }}><Spinner size="sm" /></div>
                  ) : (
                    <>
                      {/* Static Base Menu option */}
                      <div
                        style={{
                          padding: "10px 14px",
                          cursor: "pointer",
                          fontSize: "13px",
                          color: !selectedMenu ? "#53B7E8" : "#333",
                          backgroundColor: !selectedMenu ? "#eef7fd" : "#fff",
                          borderBottom: "1px solid #f5f5f5",
                          fontWeight: !selectedMenu ? 500 : 400,
                        }}
                        onMouseEnter={(e) => { if (selectedMenu) e.currentTarget.style.backgroundColor = "#f8f9fa"; }}
                        onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = !selectedMenu ? "#eef7fd" : "#fff"; }}
                        onClick={() => { setSelectedMenu(null); setShowMenuDropdown(false); }}
                      >
                        Base Menu
                      </div>

                      {menuList.length === 0 ? (
                        <div style={{ padding: "11px 14px", color: "#aaa", fontSize: "13px" }}>No menus found</div>
                      ) : (
                        menuList.map((menu) => (
                          <div
                            key={menu.id}
                            style={{
                              padding: "10px 14px",
                              cursor: "pointer",
                              fontSize: "13px",
                              color: selectedMenu?.id === menu.id ? "#53B7E8" : "#333",
                              backgroundColor: selectedMenu?.id === menu.id ? "#eef7fd" : "#fff",
                              borderBottom: "1px solid #f5f5f5",
                              fontWeight: selectedMenu?.id === menu.id ? 500 : 400,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                            onMouseEnter={(e) => { if (selectedMenu?.id !== menu.id) e.currentTarget.style.backgroundColor = "#f8f9fa"; }}
                            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = selectedMenu?.id === menu.id ? "#eef7fd" : "#fff"; }}
                            onClick={() => { setSelectedMenu(menu); setShowMenuDropdown(false); }}
                          >
                            <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{menu.name}</span>
                            <button
                              title="Edit menu"
                              style={{
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                                padding: "2px 4px",
                                flexShrink: 0,
                                marginLeft: "8px",
                                display: "flex",
                                alignItems: "center",
                                color: "#53B7E8",
                              }}
                              onClick={(e) => { e.stopPropagation(); handleEditMenu(menu); }}
                            >
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                              </svg>
                            </button>
                          </div>
                        ))
                      )}
                    </>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* ── Right group: store selector + context menu ── */}
          <div style={{ display: "flex", alignItems: "center", gap: "10px", marginLeft: "auto" }}>

            {/* Store selector – unchanged */}
            {permissions && permissions["View Inventory Management"] && (
              <StoreSelector
                options={Array.isArray(storesList) ? storesList.map(store => ({
                  value: store.value,
                  label: store.label,
                })) : []}
                value={selectedStoreID}
                onChange={(value) => {
                  setSelectedStoreID(value);
                  localStorage.setItem("selectedStoreId", value);
                }}
              />
            )}

            {/* Context menu ⋮ */}
            <div ref={contextMenuRef} style={{ position: "relative", flexShrink: 0 }}>
              <button
                title="More options"
                style={{
                  background: "#fff",
                  border: "1px solid #dee2e6",
                  borderRadius: "6px",
                  width: "36px",
                  height: "36px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "18px",
                  fontWeight: "bold",
                  color: "#555",
                  letterSpacing: "1px",
                }}
                onClick={() => setShowContextMenu((v) => !v)}
              >
                ⋮
              </button>

              {showContextMenu && (
                <div style={{
                  position: "absolute",
                  top: "calc(100% + 6px)",
                  right: 0,
                  background: "#fff",
                  border: "1px solid #dee2e6",
                  borderRadius: "6px",
                  zIndex: 1000,
                  minWidth: "170px",
                  boxShadow: "0 6px 20px rgba(0,0,0,0.10)",
                  overflow: "hidden",
                }}>
                  <div
                    style={{ padding: "11px 16px", cursor: syncloading ? "default" : "pointer", fontSize: "13px", color: "#333", borderBottom: "1px solid #f5f5f5" }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f8f9fa"}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#fff"}
                    onClick={() => { if (!syncloading) { ref2.current.click(); setShowContextMenu(false); } }}
                  >
                    {syncloading ? <Spinner size="sm" /> : "Sync Pet Pooja"}
                  </div>
                  <div
                    style={{ padding: "11px 16px", cursor: "pointer", fontSize: "13px", color: "#333", borderBottom: "1px solid #f5f5f5" }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f8f9fa"}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#fff"}
                    onClick={() => { ref.current.click(); setShowContextMenu(false); }}
                  >
                    Import Products
                  </div>
                  <div
                    style={{ padding: "11px 16px", cursor: "pointer", fontSize: "13px", color: "#333" }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f8f9fa"}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#fff"}
                    onClick={() => { getExportProduct(); setShowContextMenu(false); }}
                  >
                    {loading ? <Spinner size="sm" /> : "Export Products"}
                  </div>
                </div>
              )}
            </div>
          </div>

        </div>

        <div className="h-screen bg-white mt-3" style={{ overflow: "auto", borderRadius: "10px" }}>
          {/* Toptab – unchanged */}
          <Toptab activeTab={activeTab} setActiveTab={setActiveTab} menuId = {selectedMenu?.id} />

          {/* Content */}
          <div className="container mt-4">{/* Add content here */}</div>
        </div>
      </div>

      {/* ── Create New Menu Version Modal ────────────────────────────────────── */}
      {showCreateModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            zIndex: 2000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={(e) => { if (e.target === e.currentTarget) handleCloseCreateModal(); }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "8px",
              padding: "28px 32px",
              width: "540px",
              maxWidth: "92vw",
              maxHeight: "90vh",
              overflowY: "auto",
              boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
            }}
          >
            {/* Modal header */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px" }}>
              <h5 style={{ margin: 0, fontWeight: 600 }}>{editingMenu ? "Edit Menu Version" : "Create New Menu Version"}</h5>
              <button
                style={{ background: "none", border: "none", cursor: "pointer", fontSize: "20px", lineHeight: 1, color: "#666" }}
                onClick={handleCloseCreateModal}
              >
                ×
              </button>
            </div>

            {/* Version Name */}
            <div style={{ marginBottom: "18px" }}>
              <label style={{ display: "block", marginBottom: "6px", fontWeight: 500, fontSize: "14px" }}>
                Version Name <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                placeholder="e.g. Summer Special 2026"
                value={newMenuName}
                onChange={(e) => setNewMenuName(e.target.value)}
                style={{
                  width: "100%",
                  padding: "9px 12px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  outline: "none",
                  fontSize: "14px",
                  boxSizing: "border-box",
                }}
              />
            </div>

            {/* Clone From – hidden in edit mode */}
            {!editingMenu && <div style={{ marginBottom: "24px" }}>
              <label style={{ display: "block", marginBottom: "6px", fontWeight: 500, fontSize: "14px" }}>
                Clone From
              </label>
              <select
                value={cloneFromId}
                onChange={(e) => setCloneFromId(e.target.value)}
                style={{
                  width: "100%",
                  padding: "9px 12px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  outline: "none",
                  fontSize: "14px",
                  background: "#fff",
                  boxSizing: "border-box",
                }}
              >
              
                <option value="">Base menu</option>
                {menuList.map((menu) => (
                  <option key={menu.id} value={menu.id}>{menu.name}</option>
                ))}
              </select>
              <div style={{ marginTop: "6px", minHeight: "18px" }}>
                {cloneItemsLoading ? (
                  <span style={{ fontSize: "12px", color: "#888", display: "flex", alignItems: "center", gap: "6px" }}>
                    <Spinner size="sm" /> Fetching items from selected menu…
                  </span>
                ) : cloneFromId && cloneMenuItems.length > 0 ? (
                  <span style={{ fontSize: "12px", color: "#28a745" }}>
                    ✓ {cloneMenuItems.filter(i => i.id != null).length} item(s) will be copied into this version.
                  </span>
                ) : (
                  <span style={{ fontSize: "12px", color: "#888" }}>
                    {/* Select an existing menu to copy all its categories, items, and settings into this new version. */}
                  </span>
                )}
              </div>
            </div>}

            {/* Schedule */}
            <div style={{ marginBottom: "24px" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "10px" }}>
                <label style={{ fontWeight: 500, fontSize: "14px", margin: 0 }}>Schedule (Optional)</label>
                <button
                  type="button"
                  onClick={addScheduleRow}
                  style={{
                    background: "#53B7E8",
                    color: "#fff",
                    border: "none",
                    borderRadius: "5px",
                    padding: "4px 12px",
                    fontSize: "13px",
                    cursor: "pointer",
                  }}
                >
                  + Add Slot
                </button>
              </div>

              {schedule.map((row, index) => (
                <div
                  key={index}
                  style={{
                    border: "1px solid #e9ecef",
                    borderRadius: "6px",
                    padding: "12px",
                    marginBottom: "10px",
                    background: "#f8f9fa",
                  }}
                >
                  {/* Row header */}
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                    <span style={{ fontSize: "12px", fontWeight: 600, color: "#555", textTransform: "uppercase", letterSpacing: "0.4px" }}>
                      Slot {index + 1}
                    </span>
                    {schedule.length > 1 && (
                      <button
                        type="button"
                        onClick={() => removeScheduleRow(index)}
                        style={{ background: "none", border: "none", cursor: "pointer", color: "#dc3545", fontSize: "16px", lineHeight: 1, padding: "0 4px" }}
                        title="Remove slot"
                      >
                        ×
                      </button>
                    )}
                  </div>

                  {/* Day + times */}
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "8px", marginBottom: "8px" }}>
                    <div>
                      <label style={{ display: "block", fontSize: "11px", color: "#666", marginBottom: "4px", fontWeight: 500 }}>Day *</label>
                      <select
                        value={row.day_of_week}
                        onChange={(e) => updateScheduleRow(index, "day_of_week", e.target.value)}
                        style={{ width: "100%", padding: "6px 8px", border: "1px solid #dee2e6", borderRadius: "4px", fontSize: "13px", background: "#fff", outline: "none" }}
                      >
                        <option value="">-- Day --</option>
                        {DAYS.map((d) => (
                          <option key={d.value} value={d.value}>{d.label}</option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <label style={{ display: "block", fontSize: "11px", color: "#666", marginBottom: "4px", fontWeight: 500 }}>Start Time *</label>
                      <input
                        type="time"
                        value={row.start_time}
                        onChange={(e) => updateScheduleRow(index, "start_time", e.target.value)}
                        style={{ width: "100%", padding: "6px 8px", border: "1px solid #dee2e6", borderRadius: "4px", fontSize: "13px", outline: "none", boxSizing: "border-box" }}
                      />
                    </div>
                    <div>
                      <label style={{ display: "block", fontSize: "11px", color: "#666", marginBottom: "4px", fontWeight: 500 }}>End Time *</label>
                      <input
                        type="time"
                        value={row.end_time}
                        onChange={(e) => updateScheduleRow(index, "end_time", e.target.value)}
                        style={{ width: "100%", padding: "6px 8px", border: "1px solid #dee2e6", borderRadius: "4px", fontSize: "13px", outline: "none", boxSizing: "border-box" }}
                      />
                    </div>
                  </div>

                  {/* Date range */}
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px" }}>
                    <div>
                      <label style={{ display: "block", fontSize: "11px", color: "#666", marginBottom: "4px", fontWeight: 500 }}>Start Date</label>
                      <input
                        type="date"
                        value={row.start_date}
                        onChange={(e) => updateScheduleRow(index, "start_date", e.target.value)}
                        style={{ width: "100%", padding: "6px 8px", border: "1px solid #dee2e6", borderRadius: "4px", fontSize: "13px", outline: "none", boxSizing: "border-box" }}
                      />
                    </div>
                    <div>
                      <label style={{ display: "block", fontSize: "11px", color: "#666", marginBottom: "4px", fontWeight: 500 }}>End Date</label>
                      <input
                        type="date"
                        value={row.end_date}
                        onChange={(e) => updateScheduleRow(index, "end_date", e.target.value)}
                        style={{ width: "100%", padding: "6px 8px", border: "1px solid #dee2e6", borderRadius: "4px", fontSize: "13px", outline: "none", boxSizing: "border-box" }}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Actions */}
            <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end" }}>
              <button
                style={{
                  padding: "9px 22px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  background: "#fff",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
                onClick={handleCloseCreateModal}
              >
                Cancel
              </button>
              <button
                style={{
                  padding: "9px 22px",
                  border: "none",
                  borderRadius: "4px",
                  background: "#53B7E8",
                  color: "#fff",
                  cursor: createLoading ? "not-allowed" : "pointer",
                  fontSize: "14px",
                  opacity: createLoading ? 0.8 : 1,
                }}
                onClick={handleCreateMenu}
                disabled={createLoading}
              >
                {createLoading ? <Spinner size="sm" /> : editingMenu ? "Update Version" : "Create Version"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BaseMenu;
